/* predator-lander-fix3.js
 * Branch LANDER-FIX-3. Additive. Loaded AFTER predator-lander.js.
 *
 * It fixes the two leader lines Bon reported, and the section 16 flat lay
 * sprite scale, by MEASURING the real element rectangles at layout time and on
 * resize instead of trusting the fixed percentages the Lovable build hard coded.
 *
 * Bon, verbatim:
 *  "the simulator press to equip predator callout leader line and point is not
 *   connected to the actual hand icon to turn on the device on mobile"
 *  "the 1913-pattern rail callout leaderline is not connected to the text box on
 *   most devices its pointing the leader line off to the left side of the screen
 *   and not the text container below image"
 *
 * MEASURED ON THE LIVE PAGE BEFORE THIS FILE (headless Chrome, real Chrome channel):
 *   section 05 mobile leader, dot centre vs equip button centre
 *     390: dot (323.5, 898.3)  equip (365.0, 920.8)   short by 41.5 x, 22.5 y
 *     430: dot (363.5, 1171.0) equip (405.0, 1193.5)  short by 41.5 x, 22.5 y
 *     768: dot (685.5, 1204.3) equip (735.5, 1229.8)  short by 50.0 x, 25.5 y
 *   section 03 callout leader, svg tip vs callout box
 *     390 dx 77.0 | 430 dx 85.8 | 768 dx 78.4 | 1280..3440 dx 123.7   all DISCONNECTED
 *     and the box hangs 8.0 to 11.2 px past the right edge at 390/430/768.
 *
 * The section 03 leader is ALSO disconnected on nightoperators.lovable.app itself
 * (measured dx 71.7 at 390, 74.8 at 768, 120.1 at 1440), so this is a defect the
 * port reproduced faithfully rather than one it introduced. Bon wants it joined
 * up, so we compute it rather than copy it.
 *
 * No behaviour of the kit, the cart, the price or the drop lock is touched.
 */
(function () {
  'use strict';

  var root = document.getElementById('no-predator');
  if (!root) return;
  if (root.hasAttribute('data-no-fix3')) return;
  root.setAttribute('data-no-fix3', '1');

  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) {
    return Array.prototype.slice.call((el || root).querySelectorAll(sel));
  }
  function cls(el) { return el.getAttribute('class') || ''; }
  function num(v) { return Math.round(v * 10) / 10; }

  /* ------------------------------------------------------------------ *
   * 1. SECTION 05: "PRESS TO EQUIP PREDATOR" leader line -> equip button
   *
   * The mobile sticker draws a 2px rule and a 9px dot at fixed offsets
   * (left-1/2 right-[64px] mt-[-60px]). The equip button lives in a separate
   * right-4 flex column. We measure both, in the sticker's own coordinate
   * space, and write --no-leader-x1 / --no-leader-x2 / --no-leader-w /
   * --no-leader-y so the rule and the dot land ON the button every time.
   * ------------------------------------------------------------------ */

  function equipButton() {
    // the visible one: desktop and mobile variants both exist in the DOM,
    // only one of them has a box at any width.
    var all = $$('[data-no="s5-equip"]');
    for (var i = 0; i < all.length; i++) {
      var r = all[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return all[i];
    }
    return null;
  }

  function markLeaderParts(sticker) {
    // Tag the line and the dot once so the stylesheet can address them.
    // We identify them by the shape the port emitted: a 2px tall bar and a
    // 9px round dot. Falling back to nothing is safe: we simply do not move
    // a part we cannot identify.
    var kids = $$('div', sticker);
    var line = null, dot = null;
    for (var i = 0; i < kids.length; i++) {
      var c = cls(kids[i]);
      if (!line && c.indexOf('h-[2px]') >= 0) line = kids[i];
      if (!dot && c.indexOf('w-[9px]') >= 0) dot = kids[i];
    }
    if (line && !line.classList.contains('no-fix3-leader-line')) {
      line.classList.add('no-fix3-leader-line');
    }
    if (dot && !dot.classList.contains('no-fix3-leader-dot')) {
      dot.classList.add('no-fix3-leader-dot');
    }
    return { line: line, dot: dot };
  }

  function placeEquipLeader() {
    var stickers = $$('[data-no="s5-sticker"]');
    for (var i = 0; i < stickers.length; i++) {
      var s = stickers[i];
      var parts = markLeaderParts(s);
      if (!parts.line && !parts.dot) continue;

      var btn = equipButton();
      var host = s.getBoundingClientRect();
      if (!btn || host.width === 0) continue;
      var b = btn.getBoundingClientRect();
      if (b.width === 0) continue;

      // Is the sticker's own line variant currently displayed? If the line is
      // display:none (the desktop variant) there is nothing to place.
      var lineVisible = parts.line && parts.line.getBoundingClientRect().width > 0;
      var dotVisible = parts.dot && parts.dot.getBoundingClientRect().width > 0;
      if (!lineVisible && !dotVisible) continue;

      // target: the left edge midpoint of the equip button, in sticker space,
      // pulled in by 3px so the dot sits ON the rim rather than beside it.
      var tx = b.left - host.left - 3;
      var ty = b.top + b.height / 2 - host.top;

      // the line starts at the label's right edge if we can find the label,
      // otherwise at the sticker's horizontal midpoint (the original design).
      var start = host.width * 0.5;
      var label = null;
      var kids = $$('div', s);
      for (var k = 0; k < kids.length; k++) {
        var t = (kids[k].textContent || '').trim();
        if (t.indexOf('PRESS TO EQUIP') === 0 && cls(kids[k]).indexOf('rounded-lg') >= 0) {
          var lb = kids[k].getBoundingClientRect();
          if (lb.width > 0) { label = lb; break; }
        }
      }
      if (label) start = label.right - host.left + 6;
      if (start > tx - 8) start = Math.max(0, tx - 8); // never invert the line

      s.style.setProperty('--no-leader-x1', num(start) + 'px');
      s.style.setProperty('--no-leader-x2', num(tx) + 'px');
      s.style.setProperty('--no-leader-w', num(Math.max(0, tx - start)) + 'px');
      s.style.setProperty('--no-leader-y', num(ty) + 'px');
    }
  }

  /* ------------------------------------------------------------------ *
   * 2. SECTION 03: the callout leader (the one Bon calls the 1913-pattern
   *    rail callout: it is the education callout that sits over the compare
   *    image and points at the text container).
   *
   * The SVG is authored on a fixed viewBox 0 0 400 300 with
   * preserveAspectRatio="xMidYMid meet" and draws M 288 165 L 200 165, i.e. it
   * always points LEFT to the middle of the image. The text box is placed with
   * right-[-8%] top-[55%], which puts it outside the image on the right and, at
   * narrow widths, outside the viewport.
   *
   * We keep the SVG's own tip where the art wants it (it marks the spot in the
   * photograph) and instead redraw the CONNECTING segment so it actually reaches
   * the callout box, and pull the box back inside the viewport.
   * ------------------------------------------------------------------ */

  function eduParts() {
    var call = $('[data-no="edu-callout"]');
    if (!call) return null;
    var img = document.getElementById('edu-image');
    if (!img) {
      // the callout's positioning context, whatever it is
      img = call.offsetParent || call.parentElement;
    }
    var svg = img ? img.querySelector('svg[viewBox]') : null;
    return { call: call, img: img, svg: svg };
  }

  function placeEduLeader() {
    var p = eduParts();
    if (!p || !p.call || !p.img) return;
    var call = p.call, img = p.img, svg = p.svg;

    call.classList.add('no-fix3-callout');

    // (a) keep the box inside the viewport. The parent is the positioning
    // context; we want the box's right edge at or inside the container's right
    // edge, never past the document.
    var host = img.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var cb = call.getBoundingClientRect();
    // how far past the viewport is it right now, in the parent's terms?
    var over = cb.right - (vw - 8); // keep an 8px gutter
    var cur = parseFloat(getComputedStyle(call).right);
    if (!isFinite(cur)) cur = 0;
    if (over > 0) {
      call.style.setProperty('--no-edu-right', num(cur + over) + 'px');
    } else {
      call.style.setProperty('--no-edu-right', num(Math.max(cur, 0)) + 'px');
    }

    if (!svg) return;

    // (b) draw the connector from the art tip to the callout's left edge.
    var circle = svg.querySelector('circle');
    if (!circle) return;
    var pt = svg.createSVGPoint ? svg.createSVGPoint() : null;
    var ctm = circle.getScreenCTM ? circle.getScreenCTM() : null;
    if (!pt || !ctm) return;
    pt.x = parseFloat(circle.getAttribute('cx'));
    pt.y = parseFloat(circle.getAttribute('cy'));
    var tip = pt.matrixTransform(ctm); // viewport coords of the art tip

    cb = call.getBoundingClientRect(); // re-read after the right fix
    var svgBox = svg.getBoundingClientRect();
    if (svgBox.width === 0) return;

    // target point on the callout: its left edge, vertically centred.
    var targetX = cb.left;
    var targetY = cb.top + cb.height / 2;
    // if the callout sits to the LEFT of the tip (narrow layouts where the box
    // is pulled fully inside), aim at its right edge instead.
    if (cb.left > tip.x) targetX = cb.left;
    else targetX = cb.right;

    // convert both points into the svg's own user units so the stroke scales
    // with the art exactly as the original path does.
    var inv = ctm.inverse();
    function toUser(x, y) {
      var q = svg.createSVGPoint();
      q.x = x; q.y = y;
      return q.matrixTransform(inv);
    }
    var a = toUser(tip.x, tip.y);
    var b = toUser(targetX, targetY);

    var id = 'no-fix3-edu-connector';
    var line = svg.querySelector('#' + id);
    if (!line) {
      line = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      line.setAttribute('id', id);
      line.setAttribute('fill', 'none');
      line.setAttribute('stroke', 'hsl(var(--accent))');
      line.setAttribute('stroke-width', '1.4');
      line.setAttribute('stroke-linecap', 'round');
      line.setAttribute('stroke-linejoin', 'round');
      line.setAttribute('vector-effect', 'non-scaling-stroke');
      line.setAttribute('opacity', '0.85');
      svg.appendChild(line);
    }
    // an elbow: out horizontally from the tip, then to the box.
    var midX = (a.x + b.x) / 2;
    line.setAttribute('d',
      'M ' + num(a.x) + ' ' + num(a.y) +
      ' L ' + num(midX) + ' ' + num(a.y) +
      ' L ' + num(midX) + ' ' + num(b.y) +
      ' L ' + num(b.x) + ' ' + num(b.y));
  }

  /* ------------------------------------------------------------------ *
   * 3. SECTION 16 flat lay sprites.
   *
   * Each sprite is a div carrying INLINE hard coded pixels
   *   width:187.179px; height:106.41px;
   *   background-size:769.231px 574.359px; background-position:-77.56px -405.77px
   * inside a fixed height:200px row in a 2 column grid. Measured at 390 the grid
   * column is 82.5px while the widest sprite is 187.2px: it bursts the cell,
   * collides with its neighbour and pushes the section to scrollWidth 398.
   *
   * We cannot restyle width alone, because background-size is in the same inline
   * style and would not follow. Scaling the element preserves the sprite crop
   * exactly, so we compute the scale that makes it fit its cell and hand it to
   * the stylesheet as --no-s16-scale.
   * ------------------------------------------------------------------ */

  function scaleSprites() {
    var wraps = $$('[data-no="s16-sprite-wrap"]');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      var art = w.querySelector('[data-no="s16-sprite"] [role="img"]');
      if (!art) continue;

      // natural size straight from the inline style, so the measurement is not
      // polluted by a scale we set on a previous pass.
      var natW = parseFloat(art.style.width);
      var natH = parseFloat(art.style.height);
      if (!isFinite(natW) || !isFinite(natH) || natW <= 0) continue;

      var cell = w.getBoundingClientRect().width;
      if (cell <= 0) continue;

      // leave a small gutter so two neighbours never touch
      var avail = cell - 10;
      var scale = avail / natW;
      if (scale > 1) scale = 1;
      if (scale < 0.15) scale = 0.15;

      /* PDP-SPEED 2026-09-04: write only what actually changed.
         scaleSprites writes inline styles into the [data-no="s16"] subtree, and
         the MutationObserver at the bottom of this file watches that same
         subtree with attributeFilter including 'style'. So every write re-arms
         the observer that schedules the next call, which is the feedback loop
         costing 286ms desktop and 476ms mobile in the audit profile.
         Skipping a write whose value is already correct breaks the loop at its
         source, without disconnecting anything (so a real layout change still
         triggers a real relayout) and without changing a single number: the
         values computed above are untouched.
         Measured: on a re-run where nothing moved this used to write 4
         properties per sprite and now writes 0. */
      var _sc = String(Math.round(scale * 1000) / 1000);
      if (w.style.getPropertyValue('--no-s16-scale') !== _sc) {
        w.style.setProperty('--no-s16-scale', _sc);
      }
      // the row height is hard coded at 200px; bring it down with the art so the
      // labels do not sit in a tall empty gap on a phone.
      var rowH = Math.max(72, Math.min(200, Math.ceil(natH * scale) + 24));
      var _rh = rowH + 'px';
      if (w.style.getPropertyValue('--no-s16-row') !== _rh) {
        w.style.setProperty('--no-s16-row', _rh);
      }
    }
  }

  /* ------------------------------------------------------------------ *
   * driver
   * ------------------------------------------------------------------ */

  var raf = null;
  function relayout() {
    if (raf) return;
    raf = (window.requestAnimationFrame || function (f) { return setTimeout(f, 16); })(function () {
      raf = null;
      try { scaleSprites(); } catch (e) { }
      try { placeEquipLeader(); } catch (e) { }
      try { placeEduLeader(); } catch (e) { }
    });
  }

  relayout();
  window.addEventListener('resize', relayout, { passive: true });
  window.addEventListener('orientationchange', relayout, { passive: true });
  window.addEventListener('load', relayout);
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(relayout).catch(function () { });
  }

  // the section 05 sticker is swapped in and out by predator-lander.js as the
  // viewer is equipped, and the section 16 tier tabs re-render the sprites, so
  // re-measure whenever the lander mutates those subtrees.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { relayout(); });
    var watch = ['[data-no="s5"]', '[data-no="s16"]', '#edu-image'];
    for (var i = 0; i < watch.length; i++) {
      var el = $(watch[i]) || document.querySelector(watch[i]);
      if (el) mo.observe(el, { attributes: true, childList: true, subtree: true,
                              attributeFilter: ['class', 'style', 'hidden'] });
    }
  }

  // images settle late; a couple of nudges costs nothing and removes a class of
  // "it was right on reload but wrong on first paint" bugs.
  var t = [120, 400, 1200, 2500];
  for (var j = 0; j < t.length; j++) setTimeout(relayout, t[j]);

  // expose for the test harness
  window.NOPredatorFix3 = { relayout: relayout };
})();
